import React, { useEffect, useState, } from 'react';
import { Dialog, DialogBody, DialogDescription, DialogTitle } from '../catalyst/dialog';

import { Button } from '../catalyst/button';
import InputWithError from '../catalyst/custom/inputWithError';
import { DescriptionDetails, DescriptionList, DescriptionTerm } from '../catalyst/description-list';
import { DialogActions } from '../catalyst/dialog';
import { ErrorMessage, Field } from '../catalyst/fieldset';
import { Heading } from '../catalyst/heading';
import LoadingMain from '../components/LoadingMain';
import Spinning from '../components/spinning';
import config from '../config';


const Profile = () => {
  const [loading, setLoading] = useState(true); // State to track loading state
  const [isNameChanging, setNameChanging] = useState(false); // State to track loading state
  const [isPasswordChanging, setPasswordChanging] = useState(false); // State to track loading state


  const [name, setName] = useState('');
  const [email, setEmail] = useState(''); // Email is usually not changed
  const [tier, setTier] = useState(''); // Tier can be 'Free' or 'Premium'

  const [errResponse, setErrResponse] = useState('')

  const [openNameDialog, setOpenNameDialog] = useState(false);
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);

  const [newName, setNewName] = useState('');
  const [nameErrResponse, setNameErrResponse] = useState('')
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordFormErrors, setPasswordFormErrors] = useState({})
  const [passwordErrResponse, setPasswordErrResponse] = useState("")



  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Set loading state to true
        const response = await fetch(config.apiUrl + "/user", {
          headers: {
            'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
          }
        });

        const status = await response.status;
        if (status === 200) {
          let data = await response.json()
          setName(data.firstName)
          setEmail(data.email)
          setTier(data.premium ? 'Premium' : 'Free')
        } else {
          throw new Error('Failed to get profile');
        }

      } catch (error) {
        setErrResponse(error.message)
        console.error('Error fetching data:', error);
        setLoading(false)
      } finally {
        setLoading(false); // Set loading state to false after fetch completes

      }
    };

    fetchData();
  }, []);



  const handleNameUpdate = () => {
    setNameErrResponse("")

    if (newName.trim().length < 1) {
      setNameErrResponse("Name is required")
      return
    }

    setNameChanging(true)

    fetch(config.apiUrl + "/user/changeName", { // Replace with your actual endpoint
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ "id": JSON.parse(localStorage.getItem("user")).id, "newName": newName })
    })
      .then(response => {
        if (!response.ok) {
          if (response.status === 400) {
            return response.text().then(text => {
              throw new Error(text || 'Something went wrong');
            });
          }
          throw new Error('Sorry, some error occured. Please try again later or let us know');
        }
        return response.text();
      })
      .then(data => {
        window.location.reload();
      })
      .catch((error) => {

        setNameChanging(false)
        setNameErrResponse(error.message)
        console.error('Error:', error);
      });
  };

  const validatePasswordFormErrors = () => {
    let hasErr = false

    if ('' === oldPassword) {
      passwordFormErrors.oldPassword = "Password is required";
      hasErr = true
    } else {
      passwordFormErrors.oldPassword = null
    }
    if (newPassword.length < 6) {
      hasErr = true
      passwordFormErrors.newPassword = "New password is must have 6 letter";
    } else {
      passwordFormErrors.newPassword = null
    }
    if (newPassword !== confirmPassword) {
      hasErr = true
      passwordFormErrors.confirmPassword = "Passwords do not match";
    } else {
      passwordFormErrors.confirmPassword = null
    }
    return hasErr
  };


  const handlePasswordChange = () => {
    setPasswordFormErrors({})
    if (validatePasswordFormErrors()) {
      setPasswordFormErrors({ ...passwordFormErrors })
      return
    }


    setPasswordErrResponse("")
    setPasswordChanging(true)
    fetch(config.apiUrl + "/user/changePassword", { // Replace with your actual endpoint
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ "id": JSON.parse(localStorage.getItem("user")).id, "oldPassword": oldPassword, "newPassword": newPassword, "confirmPassword": confirmPassword })
    })
      .then(response => {
        if (!response.ok) {
          if (response.status === 400) {
            return response.text().then(text => {
              throw new Error(text || 'Something went wrong');
            });
          }
          throw new Error('Sorry, some error occured. Please try again later or let us know');
        }
        return response.text();
      })
      .then(data => {
        window.location.reload();
      })
      .catch((error) => {

        setPasswordChanging(false)
        setPasswordErrResponse(error.message)
      });
  };


  function NameDialog() {
    return (
      <Dialog open={openNameDialog} onClose={setOpenNameDialog}>
        <DialogTitle>Update Name</DialogTitle>
        <DialogDescription>
          You are about to change your profile name
        </DialogDescription>
        <DialogBody>

          <InputWithError value={newName} error={nameErrResponse} type={"name"} name={"name"} label={"Enter your new name below"} required={true} onChange={(e) => setNewName(e.target.value)} />

        </DialogBody>

        <DialogActions>

          <Button plain onClick={() => setOpenNameDialog(false)} >
            Cancel
          </Button>

          <Button onClick={handleNameUpdate} disabled={isNameChanging}>
            {isNameChanging ? <Spinning /> : "Update"}
          </Button>

        </DialogActions>
      </Dialog>
    )
  }

  function PasswordDialog() {
    return (
      <Dialog open={openPasswordDialog} onClose={() => setOpenPasswordDialog(false)}>
        <DialogTitle>Change Password</DialogTitle>


        <DialogDescription>
          Enter your old password and new password below.
        </DialogDescription>
        <DialogBody>

          <InputWithError value={oldPassword} error={passwordFormErrors.oldPassword} type={"password"} name={"oldPassword"} label={"Old Password"} required={true} onChange={(e) => setOldPassword(e.target.value)} />

          <InputWithError value={newPassword} error={passwordFormErrors.newPassword} type={"password"} name={"newPassword"} label={"New Password"} required={true} onChange={(e) => setNewPassword(e.target.value)} />

          <InputWithError value={confirmPassword} error={passwordFormErrors.confirmPassword} type={"password"} name={"name"} label={"Confirm New Password"} required={true} onChange={(e) => setConfirmPassword(e.target.value)} />


          {passwordErrResponse && <Field><ErrorMessage>{passwordErrResponse}</ErrorMessage></Field>}
        </DialogBody>


        <DialogActions>

          <Button plain onClick={() => setOpenPasswordDialog(false)} >
            Cancel
          </Button>

          <Button onClick={handlePasswordChange} disabled={isPasswordChanging}>
            {isPasswordChanging ? <Spinning /> : "Change Password"}
          </Button>

        </DialogActions>
      </Dialog>
    )
  }


  function ProfileView() {
    return (
      <>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-sm:w-full sm:flex-1">
            <Heading>Profile Details</Heading>
            <div className="mt-5">

              {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}
              <DescriptionList>

                <DescriptionTerm>Name</DescriptionTerm>
                <DescriptionDetails>{name}</DescriptionDetails>

                <DescriptionTerm>Email</DescriptionTerm>
                <DescriptionDetails>{email}</DescriptionDetails>

                <DescriptionTerm>Tier</DescriptionTerm>
                <DescriptionDetails>{tier}</DescriptionDetails>

              </DescriptionList>

            </div>
          </div>

        </div>

        <div className="mt-4">
          <Button  onClick={() => setOpenNameDialog(true)} style={{ marginRight: '10px' }}>
            Update Name
          </Button>
          <Button  onClick={() => setOpenPasswordDialog(true)}>
            Change Password
          </Button>
        </div>
        {NameDialog()}



        {PasswordDialog()}
      </>



    );
  }


  return (
    <>
      {loading ? <LoadingMain />
        : <>{ProfileView()}</>
      }
    </>
  )

};

export default Profile;
